module.exports = __webpack_public_path__ + "static/img/AmwayIcons.dff48a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/AmwayIcons.svg?5v2gxx
// module id = 0CIX
// module chunks = 0